import { STUDIO_TEXT_LIMITS } from '@/features/studio-renew/lib/studio-text-limits'

export function characterForbidden(rules: string[], name?: string) {
  const values = rules.filter((rule) => rule.trim())
  const label = name?.trim() ? `캐릭터 ‘${name}’의 금지 요청` : '금지 요청'
  let error: string | undefined
  const index = rules.findIndex(
    (rule) => rule.trim() && [...rule].length > STUDIO_TEXT_LIMITS.forbidden
  )
  if (index >= 0)
    error = `${label} ${index + 1}번은 ${[...rules[index]].length}자입니다. ${STUDIO_TEXT_LIMITS.forbidden}자 이내로 나눠 주세요.`
  else if (values.length > STUDIO_TEXT_LIMITS.forbiddenCount)
    error = `${label}은 최대 ${STUDIO_TEXT_LIMITS.forbiddenCount}개입니다. 현재 ${values.length}개입니다.`
  return { values, error }
}
